// Date (year-month) of previous month 
export const getDefaultDate = () => {
    var d = new Date();
    d.setDate(0);
    d.setTime(d.getTime() - (d.getTimezoneOffset() * 60000)); //work around toISOString UTC conversion
    return d.toISOString().slice(0,7);
    //return "2021-03-16"        //override
}

// Date of last Sunday/Wednesday
export const getDefaultWeekDate = () => {
    var d = new Date();
    d.setDate(d.getDate() - ((d.getDay() + 4) % 7 || 7));
    d.setTime(d.getTime() - (d.getTimezoneOffset() * 60000)); //work around toISOString UTC conversion
    return d.toISOString().slice(0,10);
    //return "2021-03-28"        //override
}

export const setLongmonyr = (monyr) => {
    let longmonyr = null;
    if (monyr.length <= 7) {
        const [yr,mn] = monyr.split("-");
        const date = new Date(yr, mn-1, 1);
        longmonyr = date.toLocaleString('default', { month: 'long' }) + " " + date.toLocaleDateString('en-us', { year: 'numeric' });
    } else {
        const [yr,mn,dy] = monyr.split("-");
        const date = new Date(yr, mn-1, dy);
        longmonyr = date.toLocaleString('default', { month: 'long' }) + " " + date.toLocaleDateString('en-us', { day: 'numeric' }) + ", " + date.toLocaleDateString('en-us', { year: 'numeric' });
    }
    return longmonyr;
}

export const idToNetwork = (sid, name) => {
    if (name.slice(0, 6) === "Gridpt") {
        return "PRISM";		
    } else if (sid.slice(0, 3) === "USW" || sid.slice(0, 3) === "USC") {
        return "NWS";
    } else if (sid.slice(0, 3) === "US1") {
        return "CoCoRaHS";
    }
    const isDcr = /^[A-Z]{3}\d{3}$/.test(sid); 	
    if (isDcr) {
        return "DCR";
    } else {
        return "-";
    }
}
